/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Id_Required_ErrorInputs */

const en_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group ID is required`)
};

const fr_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du groupe d'evenements requis`)
};

const de_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisgruppen-ID ist erforderlich.`)
};

const it_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È richiesto l'ID del gruppo di eventi`)
};

const ru_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется идентификатор группы событий.`)
};

const es_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere el ID del grupo de eventos`)
};

const zh_cn2_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组 ID 为必填项`)
};

const ja_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループIDが必要です`)
};

const hi_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप आईडी आवश्यक है`)
};

const pt_pt2_iframe_remote_event_group_id_required_error = /** @type {(inputs: Iframe_Remote_Event_Group_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário o ID do grupo de eventos.`)
};

/**
* | output |
* | --- |
* | "Event group ID is required" |
*
* @param {Iframe_Remote_Event_Group_Id_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_id_required_error = /** @type {((inputs?: Iframe_Remote_Event_Group_Id_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Id_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "de") return de_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "it") return it_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "ru") return ru_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "es") return es_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "ja") return ja_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "hi") return hi_iframe_remote_event_group_id_required_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_event_group_id_required_error(inputs)
	return en_iframe_remote_event_group_id_required_error(inputs)
});